export default __webpack_public_path__ + "static/article-surviving-the-silly-season-b7593b0c451e2252b183de12049cec07.jpg";